import styled from 'styled-components/macro';
import SecondaryButton from 'styled/Buttons/SecondaryButton';

const TelegramButton = styled(SecondaryButton)`
  height: 24px;
  padding: 0 10px;
  margin-right: 10px;
`;

export default TelegramButton;
